import DonationsInfoBox from './DonationsInfoBox.component';
export default DonationsInfoBox;